import colors from "@moodys/mdc-frontend.theming.colors";
import { alpha } from "@mui/material/styles";
export const palette = {
    mode: "light",
    common: {
        black: colors.globalBlack,
        white: colors.globalWhite,
        brightBlue: colors.globalBrightBlue07,
    },
    primary: {
        main: colors.globalBlue700,
        dark: colors.globalBlue800,
        light: colors.globalBlue600,
        contrastText: colors.globalWhite,
    },
    secondary: {
        main: colors.globalGreen300,
        dark: colors.globalGreen400,
        light: colors.globalGreen200,
        contrastText: colors.globalBlack,
    },
    error: {
        main: colors.globalRed500,
        dark: colors.globalRed600,
        light: colors.globalRed400,
        contrastText: colors.globalWhite,
    },
    warning: {
        main: colors.globalOrange500,
        dark: colors.globalOrange600,
        light: colors.globalOrange400,
        contrastText: colors.globalWhite,
    },
    info: {
        main: colors.globalCyan500,
        dark: colors.globalCyan600,
        light: colors.globalCyan400,
        contrastText: colors.globalWhite,
    },
    success: {
        main: colors.globalLightGreen500,
        dark: colors.globalLightGreen600,
        light: colors.globalLightGreen400,
        contrastText: colors.globalWhite,
    },
    grey: {
        100: colors.globalGray100,
        200: colors.globalGray200,
        300: colors.globalGray300,
        400: colors.globalGray400,
        500: colors.globalGray500,
        600: colors.globalGray600,
        700: colors.globalGray700,
        800: colors.globalGray800,
    },
    text: {
        primary: colors.globalBlack,
        secondary: colors.globalGray600,
        disabled: colors.globalGray400,
    },
    link: {
        main: colors.globalBlue500,
        dark: colors.globalBlue600,
        light: colors.globalBlue400,
    },
    divider: alpha(colors.globalBlack, 0.12),
    outlinedBorder: alpha(colors.globalBlack, 0.24),
    backdropOverlay: alpha(colors.globalBlack, 0.5),
    filledInputBackground: alpha(colors.globalBlack, 0.06),
    snackbar: colors.globalBlue700,
    skeleton: alpha(colors.globalBlue700, 0.04),
    background: {
        paper: colors.globalWhite,
        default: colors.globalDarkBlue050,
    },
    chipOutlinedBorder: alpha(colors.globalBlue700, 0.3),
    buttonBorderColor: colors.globalBlue700,
    action: {
        active: alpha(colors.globalBlue700, 0.54),
        activatedOpacity: 0.12,
        hover: alpha(colors.globalBlue700, 0.04),
        hoverOpacity: 0.04,
        selected: alpha(colors.globalBlue700, 0.08),
        selectedOpacity: 0.08,
        focus: alpha(colors.globalBlue700, 0.12),
        focusOpacity: 0.12,
        disabled: alpha(colors.globalBlue700, 0.26),
        disabledOpacity: 0.38,
        disabledBackground: alpha(colors.globalBlue700, 0.12),
        focusOutline: colors.globalCyan600,
        deselected: alpha(colors.globalBlue700, 0.75),
        deselectedOpacity: 0.75,
        deselectedLight: alpha(colors.globalBlue700, 0.4),
        deselectedLightOpacity: 0.4,
    },
};
export const darkPalette = {
    mode: "dark",
    primary: {
        main: colors.globalBlue100,
        dark: colors.globalBlue200,
        light: colors.globalWhite,
        contrastText: colors.globalBlue700,
    },
    secondary: {
        main: colors.globalGreen300,
        dark: colors.globalGreen400,
        light: colors.globalGreen200,
        contrastText: colors.globalBlack,
    },
    error: {
        main: colors.globalRed300,
        dark: colors.globalRed400,
        light: colors.globalRed200,
        contrastText: colors.globalBlack,
    },
    warning: {
        main: colors.globalOrange300,
        dark: colors.globalOrange400,
        light: colors.globalOrange200,
        contrastText: colors.globalBlack,
    },
    info: {
        main: colors.globalCyan300,
        dark: colors.globalCyan400,
        light: colors.globalCyan200,
        contrastText: colors.globalBlack,
    },
    success: {
        main: colors.globalLightGreen300,
        dark: colors.globalLightGreen400,
        light: colors.globalLightGreen200,
        contrastText: colors.globalBlack,
    },
    text: {
        primary: colors.globalWhite,
        secondary: alpha(colors.globalWhite, 0.75),
        disabled: alpha(colors.globalWhite, 0.4),
    },
    link: {
        main: colors.globalBlue300,
        dark: colors.globalBlue400,
        light: colors.globalBlue200,
    },
    divider: alpha(colors.globalWhite, 0.22),
    outlinedBorder: alpha(colors.globalWhite, 0.5),
    backdropOverlay: alpha(colors.globalBlack, 0.6),
    filledInputBackground: alpha(colors.globalWhite, 0.09),
    buttonBorderColor: colors.globalBlue200,
    snackbar: colors.globalWhite,
    skeleton: alpha(colors.globalBlue100, 0.11),
    background: {
        paper: colors.globalBlue700,
        default: colors.globalBlue800,
    },
    chipOutlinedBorder: alpha(colors.globalBlue100, 0.3),
    action: {
        active: alpha(colors.globalBlue100, 0.7),
        activatedOpacity: 0.18,
        hover: alpha(colors.globalBlue100, 0.11),
        hoverOpacity: 0.11,
        selected: alpha(colors.globalBlue100, 0.16),
        selectedOpacity: 0.16,
        focus: alpha(colors.globalBlue100, 0.18),
        focusOpacity: 0.18,
        disabled: alpha(colors.globalBlue100, 0.3),
        disabledOpacity: 0.4,
        disabledBackground: alpha(colors.globalBlue100, 0.1),
        focusOutline: colors.globalCyan400,
        deselected: alpha(colors.globalWhite, 0.75),
        deselectedOpacity: 0.75,
        deselectedLight: alpha(colors.globalWhite, 0.4),
        deselectedLightOpacity: 0.4,
    },
};
//# sourceMappingURL=palette.js.map